(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      if (this.slider) {
        this.slider.destroy();
      }
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) {
        return;
      }

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 20,
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
